import { useQueueChatPauseContext } from 'hooks/useQueuePauseChatServicePanel';
import React from 'react';
import { Button, InputGroupAddon } from 'reactstrap';
import { MESSAGES } from 'views/shared/helpers/Messages';
import { useClickToCallOnPhoneField } from '../../hooks/useClickToCallOnPhoneField';
import { agentIsPausedOrLoggedOut } from 'views/shared/helpers/checkIfAgentOnPauseOrLogouf';

export const InputWithButtonWhatsapp = ({ phoneValue, handlerAction }) => {
  const { messageSendingBlocked } = useQueueChatPauseContext();
  const { canSendMessage } = useClickToCallOnPhoneField();

  return (
    <InputGroupAddon addonType="append">
      <Button
        type="button"
        color="info"
        title={
          messageSendingBlocked
            ? MESSAGES.ON_PAUSE_OR_NOT_LOGGED
            : 'Enviar mensagem'
        }
        disabled={!canSendMessage(phoneValue)}
        style={{ cursor: messageSendingBlocked ? 'not-allowed' : 'pointer' }}
        onClick={() => {
          if (agentIsPausedOrLoggedOut(messageSendingBlocked)) {
            return;
          }
          handlerAction(phoneValue);
        }}
      >
        <i className="fas fa-comment" />
      </Button>
    </InputGroupAddon>
  );
};
